var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 490.147,
    height: 204.021,
    viewBox: "0 0 52.25 21.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595 0h.273v841.89H595zm0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-288.184 561.346)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(.834 .333) scale(.35278)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M595.277 841.89h564.094V0H595.277zm0 0"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    x: 275.69,
    y: 670.252,
    fill: "#211e1e",
    transform: "translate(-82.19 -83.588) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    x: 234.171,
    y: 683.252,
    fill: "#211e1e",
    transform: "translate(-82.19 -83.588) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 164.616,
    y: 442.901,
    fill: "#4c4a4c",
    transform: "translate(-155.907 -116.753) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 417.752,
    y: 445.901,
    fill: "#26429e",
    transform: "translate(-155.907 -116.753) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: "100%",
    height: "100%",
    x: 556.612,
    y: 476.901,
    fill: "#4c4a4c",
    transform: "translate(-155.907 -116.753) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 462.563,
    y: 507.901,
    fill: "#26429e",
    transform: "translate(-155.907 -116.753) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 423.242,
    y: 551.901,
    fill: "#4c4a4c",
    transform: "translate(-155.907 -116.753) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 418.252,
    y: 582.901,
    fill: "#4c4a4c",
    transform: "translate(-155.907 -116.753) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: "100%",
    height: "100%",
    x: 477.193,
    y: 613.901,
    fill: "#4c4a4c",
    transform: "translate(-155.907 -116.753) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    width: "100%",
    height: "100%",
    x: 264.196,
    y: 64.52,
    fill: "#232830",
    transform: "translate(-232.63 -148.208) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    width: "100%",
    height: "100%",
    x: 442.279,
    y: 578.78,
    fill: "#512685",
    transform: "translate(29.168 -302.46) scale(.35278)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    width: "100%",
    height: "100%",
    x: 211.224,
    y: 218.392,
    transform: "translate(166.863 -419.388) scale(.35278)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M288.316-543.512H340.3v-11.66h-51.985zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b61ab",
    d: "M288.688-543.886h51.242v-10.91h-51.242zm0 0"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.303-546.61h1.278v-2.64l2.078-2.81h-1.363l-1.24 1.724-1.126-1.724h-1.553l1.926 2.864zm3.91 0h3.347v-1.146h-2.1v-1.079h1.773v-1.116h-1.773v-.985h2.07v-1.124h-3.317zm4.544-1.539.106 1.454c.27.086.523.149.761.194.237.045.46.068.668.068.62-.011 1.1-.18 1.443-.504.343-.328.517-.751.523-1.274-.007-.424-.133-.763-.377-1.017a3.77 3.77 0 0 0-.963-.693l-.632-.353a.849.849 0 0 1-.28-.23.433.433 0 0 1-.094-.263.39.39 0 0 1 .157-.321c.102-.077.246-.117.43-.119.146 0 .334.04.561.123.227.083.484.214.772.394v-1.277a5.639 5.639 0 0 0-.722-.204 2.979 2.979 0 0 0-.641-.073c-.54.008-.966.151-1.279.43-.313.277-.471.634-.478 1.07-.001.323.084.61.255.867.17.257.432.485.787.688l.365.208c.277.154.496.29.654.406.16.119.24.268.244.448a.464.464 0 0 1-.195.38c-.129.097-.309.15-.543.152a2.032 2.032 0 0 1-.751-.15c-.243-.1-.5-.233-.77-.404m24.457 1.539h.913v-3.464l3.479 3.64h.099v-5.626h-.92v3.463l-3.472-3.64h-.1zm6.209 0h.936v-2.547l2.428 2.546h1.218l-2.717-2.832 2.458-2.617h-1.095l-2.292 2.433v-2.433h-.936zm-14.068-14.604-11.813 21.43-4.054-4.102h2.795zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d71c23",
    d: "m316.879-558.913-10.416 18.519-3.078-3.116h2.085zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m321.762-548.357.89-2.032.876 2.032zm-.792 1.748.44-.97h2.452l.435.97h.996l-2.556-5.628h-.078l-2.647 5.628zm-4.193-3.186v-1.541h.518c.35-.003.612.055.784.17.173.118.259.305.259.562a.728.728 0 0 1-.263.588c-.173.143-.42.216-.743.22zm0 2.422v-1.7h.662c.333 0 .583.075.754.219.172.144.258.348.26.613-.002.278-.09.493-.264.643-.174.15-.417.225-.739.226zm-.913.764v-5.45h1.608c.44 0 .983.071 1.344.355.299.234.449.577.449 1.03 0 .274-.069.508-.21.7-.139.195-.354.347-.642.454.31.08.55.234.718.462s.254.514.255.856c0 .533-.17.932-.514 1.197-.343.263-.858.396-1.547.394l-1.46.001zm0 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesBank);
export default __webpack_public_path__ + "static/media/yes-bank.a1f332a1f51cecebd143c62a55b6d641.svg";
export { ForwardRef as ReactComponent };